import { Input, Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import styles from '../AiForm.module.css'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { seedAtom } from './atom'
import { useAtom } from 'jotai'

export const SeedComp: React.FC<{
  disabled: boolean
}> = ({ disabled }) => {
  const [seed, setSeed] = useAtom(seedAtom)

  return (
    <MyForm.Item
      label={
        <span>
          随机种子{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="通过随机种子（Seed）确定扩散的初始状态，进而控制生成的样本的多样性"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-3')}
    >
      <Input
        placeholder={'请输入随机种子'}
        type="number"
        min={1}
        allowClear
        className={styles.colorLessInput}
        value={seed}
        onChange={e => {
          if (!!e.target.value) {
            const _val = Math.floor(Number(e.target.value))
            setSeed(Math.max(1, _val).toString())
          }
        }}
        disabled={disabled}
      />
    </MyForm.Item>
  )
}
